import { createSlice } from '@reduxjs/toolkit';

type ApplySetupBarInitialState = {
  applySetupBarError: boolean;
  isLoading: boolean;
};

export const INITIAL_APPLY_SETUP_BAR_STATE: ApplySetupBarInitialState = {
  applySetupBarError: false,
  isLoading: true,
};

const applySetupBarSlice = createSlice({
  name: 'applySetupBar',
  initialState: INITIAL_APPLY_SETUP_BAR_STATE,
  reducers: {
    setApplySetupBarError: (state, action) => {
      state.applySetupBarError = action.payload;
    },
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
  },
});

export const { setApplySetupBarError, setIsLoading } =
  applySetupBarSlice.actions;

export default applySetupBarSlice.reducer;
